// @flow

import React from 'react';
import styled from 'styled-components';
import {
  InputContainer,
  InputContainerProps,
  InputField,
  InputFieldProps,
} from './components';
import PropTypes from 'prop-types';

const InputMultilineField = styled(InputField)`
  resize: none;
  line-height: 1.5;
`;

type Props = {
  id: string,
  label?: string,
  maxLength?: string,
  isValid?: boolean,
  errorMessage?: string,
  disabled?: boolean,
  onChange?: (evt: SyntheticInputEvent<HTMLInputElement>) => ?boolean,
  multiline?: boolean,
  rows?: number,
  fieldSuffix?: string,
  placeholder?: string,
};

const TextInput = ({
  fieldSuffix,
  id,
  label,
  isValid,
  errorMessage,
  multiline,
  rows,
  ...rest
}: Props) => {
  return (
    <InputContainer
      suffix={fieldSuffix}
      id={id}
      label={label}
      isValid={isValid}
      errorMessage={errorMessage}
    >
      {multiline ? (
        <InputMultilineField
          as="textarea"
          id={id}
          data-testid={id}
          rows={rows ? rows : 4}
          fieldSuffix={fieldSuffix}
          isValid={isValid}
          {...rest}
        />
      ) : (
        <InputField
          type="text"
          id={id}
          data-testid={id}
          fieldSuffix={fieldSuffix}
          isValid={isValid}
          {...rest}
        />
      )}
    </InputContainer>
  );
};

export default TextInput;

export const TextInputProps = {
  ...InputContainerProps,
  ...InputFieldProps,
  maxLength: PropTypes.string,
  disabled: PropTypes.bool,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
